import { i18n } from "@/i18n";
import { analyticsTagsConstantes } from "@/constantes/analyticsTags";

export default {
  path: "/studea-manager/shared-document",
  name: "studeaManagerSharedDocument",
  component: () => import(/* webpackChunkName: "global" */ "@/views/Global/GlobalLayoutWithErrorView.vue"),
  meta: {
    authRequired: true,
    title: i18n.global.t("studea_manager.document.shared_documents"),
    breadcrumb: true,
  },
  children: [
    {
      path: "add",
      name: "studeaManagerSharedDocumentAdd",
      component: () =>
        import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Document/SharedDocumentAddEditView.vue"),
      meta: {
        title: i18n.global.t("studea_manager.document.shared_document_add"),
        breadcrumb: true,
        trackPageView: true,
        trackPageViewTagId: analyticsTagsConstantes.PILOT_SHARED_DOCUMENT_ADD_FORM,
      },
    },
    {
      path: "edit/:id",
      name: "studeaManagerSharedDocumentEdit",
      component: () =>
        import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Document/SharedDocumentAddEditView.vue"),
      meta: {
        title: i18n.global.t("studea_manager.document.shared_document_edit"),
        breadcrumb: true,
        trackPageView: true,
        trackPageViewTagId: analyticsTagsConstantes.PILOT_SHARED_DOCUMENT_EDIT,
      },
    },
    {
      path: "list",
      name: "studeaManagerSharedDocumentList",
      component: () =>
        import(/* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/Document/SharedDocumentListView.vue"),
      meta: {
        title: i18n.global.t("studea_manager.document.shared_document_list"),
        breadcrumb: true,
        trackPageView: true,
        trackPageViewTagId: analyticsTagsConstantes.PILOT_DASHBOARD_SHARED_DOCUMENTS,
      },
    },
  ],
};
